module.exports = __webpack_public_path__ + "img/category-fishing-game.51269a7c.png";